import * as types from "../constants/notificationConstants";
import { LOGOUT } from "../constants/authConstants";

const initialState = {
    notifications: [],
    pending: false
};

const notificationReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case LOGOUT:
            return {
                ...state,
                notifications: [],
                pending: false
            };

        case types.GET_NOTIFICATION_SUCCESS:
            let p = false
            // console.log('payload',payload)
            if (Array.isArray(payload) && payload.length > 0) {
                p = true;
            }
            return { ...state, notifications: payload, pending: p };

        case types.GET_NOTIFICATION_FAIL:
            return { initialState };



        default:
            return state;
    }
};

export default notificationReducer;